export default () => ({
    image_url: '',
    video_type: '',
    video_id: null,
    video_params: {},
    show_player: false,
    show_player_on_init: false,
    is_initialized: false,
    autoplay: false,
    init() {

        // noinspection JSUnresolvedReference
        this.image_url = this.$root.dataset.dummyThumbnailUrl;

        // noinspection JSUnresolvedReference
        this.video_url = this.$root.dataset.videoUrl;

        this.video_type = this.parseVideoType();

        // noinspection JSUnresolvedReference
        this.show_player_on_init = !!parseInt(this.$root.dataset.showPlayerOnInit);

        // noinspection JSUnresolvedReference
        this.autoplay = !!parseInt(this.$root.dataset.autoplay);

        this.parseVideoId();

        this.swiper.on('slideChange', () => {
            this.show_player = false;
        });

        this.swiper.on('sliderMove', () => {
            this.show_player = false;
        });

        this.show_player = this.show_player_on_init;

        this.is_initialized = true;
    },
    root: {
        ['x-bind:style']() {
            return {
                backgroundImage: this.image_url
                    ? `url('` + this.image_url + `')`
                    : null
            }
        },
        ['x-intersect.once']() {
            this.loadThumbnail()
        }
    },
    iframe: {
        ['x-bind:src']() {

            if (this.video_type === 'youtube') {

                let params = 'loop=0&rel=0&wmode=transparent&listType=user_uploads'

                if (this.autoplay) {
                    params += '&autoplay=1&mute=1';
                }

                return `https://www.youtube.com/embed/${this.video_id}?${params}`;
            }

            if (this.video_type === 'vimeo') {

                let params = '';

                if (this.autoplay) {
                    params += '&autoplay=1&muted=1';
                }

                return `https://player.vimeo.com/video/${this.video_id}?${params}`;
            }

            if (this.video_type === 'vk') {

                const params = {}

                if (this.video_id.oid) {
                    params.oid = this.video_id.oid;
                }

                if (this.video_id.id) {
                    params.id = this.video_id.id;
                }

                if (this.video_id.hash) {
                    params.hash = this.video_id.hash;
                }

                params.hd = 2;

                if (this.autoplay) {
                    params.autoplay = 1;
                }

                const searchParams = new URLSearchParams(params);

                return `https://vk.com/video_ext.php?${searchParams.toString()}`
            }

            if (this.video_type === 'rutube') {

                this.video_params.skinColor = 'e53935';

                const searchParams = new URLSearchParams(this.video_params)

                return `https://rutube.ru/play/embed/${this.video_id}?` + searchParams.toString();
            }

            return null;
        }
    },
    fetchYoutubeThumbnails(index, image_urls) {

        if (index >= image_urls.length) {
            return;
        }

        // Загрузка через HTMLImageElement для обхода CORS
        let img     = new Image();
        img.src     = image_urls[index];
        img.onload  = () => {
            console.log('video thumbnail loaded', image_urls[index]);
            if (img.naturalWidth >= 320) {
                this.image_url = image_urls[index];
            } else {
                this.fetchYoutubeThumbnails(index + 1, image_urls);
            }
        };
        img.onerror = () => {
            console.log('error on loading video thumbnail', image_urls[index]);
            this.fetchYoutubeThumbnails(index + 1, image_urls);
        }
    },
    loadThumbnail() {

        // noinspection JSUnresolvedReference
        let custom_thumbnail_url = this.$root.getAttribute('data-custom-thumbnail-url');

        // Установлена отдельная картинка
        if (custom_thumbnail_url) {
            this.image_url = custom_thumbnail_url;
            return;
        }

        // Идентификатор видео не указан
        if (!this.video_id) {
            return;
        }

        // Тип видео YouTube
        if (this.video_type === 'youtube') {

            let image_urls = [
                `https://img.youtube.com/vi/${this.video_id}/sddefault.jpg`,
                `https://img.youtube.com/vi/${this.video_id}/mqdefault.jpg`,
                `https://img.youtube.com/vi/${this.video_id}/hqdefault.jpg`,
                `https://img.youtube.com/vi/${this.video_id}/maxresdefault.jpg`,
            ];

            this.fetchYoutubeThumbnails(0, image_urls);
        }

        // Тип видео Vimeo
        if (this.video_type === 'vimeo') {
            fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${this.video_id}?&width=1280&height=720`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Не удалось загрузить изображение Vimeo');
                    }
                    return response.json();

                })
                .then(data => {
                    this.image_url = data.thumbnail_url;
                })
                .catch(error => {
                    console.error('Error fetching JSON:', error);
                });
        }

        // Тип видео RuTube
        if (this.video_type === 'rutube') {
            this.image_url = `https://rutube.ru/api/video/${this.video_id}/thumbnail/?redirect=1`;
        }
    },
    parseVideoType() {

        if (this.video_url.includes('youtu')) {
            return 'youtube';
        }

        if (this.video_url.includes('vimeo')) {
            return 'vimeo';
        }

        if (['vk.com', 'vk.ru', 'vkvideo.ru'].some(domain => this.video_url.includes(domain))) {
            return 'vk';
        }

        if (this.video_url.includes('rutube')) {
            return 'rutube';
        }

        return 'unknown';
    },
    parseVideoId() {

        if (this.video_type === 'youtube') {
            const regex   = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/|shorts\/)|(?:(?:watch)?\?vi?=|&vi?=))([^#&?]*).*/;
            let matches   = this.video_url.match(regex);
            this.video_id = matches[1] ?? null;

            return this.video_id;
        }

        if (this.video_type === 'vimeo') {
            const regex   = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/
            let matches   = this.video_url.match(regex);
            this.video_id = matches[5] ?? null;

            return this.video_id;
        }

        if (this.video_type === 'vk') {
            if (this.video_url.includes('video_ext.php?')) {
                const oid_regex  = /[?&]oid=(-?\d+)/
                const id_regex   = /[?&]id=(-?\d+)/
                const hash_regex = /[?&]hash=(-?[a-zA-Z0-9]+)/
                let oid_matches  = this.video_url.match(oid_regex);
                let id_matches   = this.video_url.match(id_regex);
                let hash_matches = this.video_url.match(hash_regex);

                this.video_id = {
                    oid: Array.isArray(oid_matches)
                    && oid_matches.length > 1 ? oid_matches[1] : null,
                    id: Array.isArray(id_matches)
                    && id_matches.length > 1 ? id_matches[1] : null,
                    hash: Array.isArray(hash_matches)
                    && hash_matches.length > 1 ? hash_matches[1] : null
                }

                return this.video_id;
            }

            const regex = /vk(?:\.com|\.ru|video\.ru)\/video(-?\d+)_(\d+)/
            let matches = this.video_url.match(regex);

            this.video_id = {
                oid: matches[1] ?? null,
                id: matches[2] ?? null
            };

            return this.video_id;
        }

        if (this.video_type === 'rutube') {

            let regex = /rutube.ru\/(video|play\/embed)\/([\da-z]+)/
            if (this.video_url.includes('video/private')) {
                regex = /rutube.ru\/(video)\/private\/([\da-z]+)/
            }

            let matches   = this.video_url.match(regex);
            this.video_id = matches[2] ?? null;

            // Ключ доступа (?p=)
            const urlObj         = new URL(this.video_url);
            const params         = new URLSearchParams(urlObj.search);
            const allowedParams  = ['p'];
            const filteredParams = {};
            for (const [key, value] of params.entries()) {
                if (allowedParams.includes(key)) {
                    filteredParams[key] = value;
                }
            }
            this.video_params = filteredParams;

            return this.video_id;
        }

        return false;
    },
    showPlayer() {

        if (this.video_type === 'unknown') {
            window.open(this.video_url, '_blank').focus();
            return;
        }

        // noinspection JSUnresolvedReference
        const slideIndex = this.swiper.slides.indexOf(this.$root.closest('.swiper-slide'));

        this.swiper.slideTo(slideIndex);

        this.show_player = true;
    }
});
